import API from '@/assets/js/libs/API'

export default {
  addNewManager: (managerObj) => API.post('manager', managerObj),
  deleteManager: (id) => API.delete(`manager/${id}`),
  getManagerInfo: (id) => API.get(`manager/${id}`),
  getManagerList: () => API.get('manager/list'),
  login: (loginInfoObj) => API.post('login', loginInfoObj),
  updatePassword: (id, passwordObj) =>
    API.put(`manager/pwd/${id}`, passwordObj),
  updateUserInfo: (id, managerObj) => API.put(`manager/${id}`, managerObj),
}



// WEBPACK FOOTER //
// ./src/API/managerService.js